import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { mapAnalyticsRoutes } from './map-analytics.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { MapAnalyticsComponent } from './map-analytics.component'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { AnalyticsMapModule } from '@components/analytics-map/analytics-map.module'

@NgModule({
  declarations: [MapAnalyticsComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(mapAnalyticsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    ContentEditableModule,
    AnalyticsMapModule,
  ],
  exports: [],
})
export class MapAnalyticsModule {}
